<template>
  <div v-if="type === 'loader'" class="card">
    <div class="card__image"></div>
    <div class="card__body">
      <h3 class="card__title loading">New Information on Lassa Fever</h3>
      <p class="loading">Lassa fever, also known as Lassa hemorrhagic fever (LHF), with the common symptoms of Fever…</p>
      <div class="card__meta d-flex align-items-center loading">
        <span>by John Doe, 6 hours ago</span>
      </div>
    </div>
  </div>
  <div v-else class="card">
    <div v-if="article.first_media.media_uploads.length > 0" class="card__image" :style="'background-image: url('+article.first_media.media_uploads[0].upload.path+')'">
	</div>
    <div class="card__body">
      <h3 class="card__title">{{article.title}}</h3>
      <p v-html="truncatedBody"></p>
      <div class="card__meta d-flex align-items-center">
        <span>by {{article.profile.name}}, {{article.created | happroxy(true)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'BlogCard',
	props: ["type", "article"],
	computed: {
		truncatedBody: function() {
			return `${this.article.first_media.body.split('').splice(0, 100).join('')}...`;
		}
	}
}
</script>

<style lang="scss" scoped>
.loading {
	background: whitesmoke !important;
	color: transparent !important;
}
.card {
	background: #fff;
	margin-bottom: 30px;
	&__image {
		background: #14264d;
		border-radius: 6px 6px 0 0;
		height: 180px;
		background-size: cover;
		background-position: center center;
		overflow: hidden;
	}
	&__body {
		padding: 20px;
	}
	&__title {
		font-size: 20px;
	}
	&__meta {
		color: #919EAB;
		font-size: 13px;
	}
}
</style>